import { useState,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CheckTrue } from "../../assets/svg/check-true.svg";
import { ReactComponent as CheckFalse } from "../../assets/svg/check-false.svg";
import { ReactComponent as ArrowRight } from "../../assets/svg/arrow-right.svg";
import { ReactComponent as Organization } from "../../assets/svg/organization.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../visitor/visitor-create/visitor-create.css";
import GuestImage from "../../assets/svg/guest-photo.svg";
import { getFailedCheckList } from "../visitor/visitor-api";

 const CheckListFailedAdminModal = ({checkList,moduleId,moduleName, visitorName, organization, visitorPicture, isSaveEnable, onSave,isApprovedEnable,onApproved,isRejectedEnable,onRejected, onCancel }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
      const [errorCheckList, setErrorCheckList]=useState([]);
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",          
          padding: "16px 24px",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "464px",
          height:"493px",
          overflowY: "auto",
        },
      };
        useEffect(() => {
          if(checkList!==null && checkList.length>0){
            setErrorCheckList(checkList) 
           
          }else{
            checkListFailsUpdate()
          }
         
          },[checkList]);
const checkListFailsUpdate = async () => {   
            try {
              const response = await getFailedCheckList(moduleId,moduleName);
              if (response.success === true) {
                setErrorCheckList(response.suggestionlist)
              }
          return response.data;
            } catch (err) {
              console.error("Error fetching category:", err);
            } finally {
            }
          };
       
         
    return ( <div style={modalStyle.overlay}>
        <div style={modalStyle.modal}>
          <div style={{ color: "#ffffff" }}>
            <div>
              <div className="checklist-modal-title"
    >
    Approve {moduleName}? 
    </div>
    <div className="checklist-modal-sub-title mt-2">
    Some checklist items have failed. Are you sure you want 
to approve this visitor for gate entry? This action cannot be undone.
                    </div>
     
            </div>

            <div style={{marginTop:'8px' }}>
           
           <div className="approver-box style-justify-start">
           <img className="approver-image" src={visitorPicture!=null && visitorPicture!==""?visitorPicture:GuestImage} alt="guest"/> 
           <div style={{paddingLeft:'8px'}}>
            <div className="item-add-title">
            {visitorName??''}
            </div>
            <div className=" style-justify-start">
            <Organization/> <span className="approver-txt">{organization??''}</span>
            </div>
           </div>
           </div>
                            
           <div className="mt-3">
            <div className="checklist-title-txt">
            Check lists 
            </div>
            </div>    
              
           <div style={{height:'156px', overflowY:'scroll'}}>
           {errorCheckList.map((check, index) =>{
          return <div key={'checklist'+index} className="checklist-card style-justify-between mt-1">
            <div className="style-justify-start">
              <ArrowRight/> <span className="check-list-name-modal"> {check.name}{check.checkname} </span>
            </div>
            <div className="style-justify-start">
            <span className={`check-list-name-modal ${check.status===false || check.status==='false'?'check-list-value-failed':'check-list-value-success'}`}> {check.value==='true'?'Yes':check.value==='false'?'No':check.value}</span> {check.status===false|| check.status==='false'?<CheckFalse/>:<CheckTrue/>}   
            </div>
          </div>
           })}
           </div>
              
             
              <Row className="mt-3"                
              >
                <div className="style-justify-end">
                <div
                  onClick={onCancel} className="admin-checklist-cancel-btn style-justify-center"                  
                >
                 Cancel
                </div>

               {isSaveEnable!=null && isSaveEnable===true && (<div
                  onClick={onSave} className="admin-checklist-submit-btn style-justify-center"                  
                >
                 Submit
                </div>)}

                {isApprovedEnable!=null && isApprovedEnable===true && (<div className="admin-checklist-approve-btn style-justify-center"
                  onClick={onApproved}>
                  Yes, Approve
                </div>)}
                {isRejectedEnable!=null && isRejectedEnable===true && (<div className="admin-checklist-reject-btn style-justify-center"
                  onClick={onRejected}>
                  Yes, Reject
                </div>)}
                </div>
              </Row>
            </div>
          </div>
        </div>
      </div>);

}

export default CheckListFailedAdminModal;